<div
    class="slide-wrapper"
    ngClass.xs="slide-wrapper__mobile"
    fxLayout
    fxFlex="0 0 100%"
    [fxLayoutAlign]="getBottomContentAlignment()"
    [ngStyle]="getStyles()"
>
    <!-- Image -->
    <a
        *ngIf="item?.layoutContent?.banner.image"
        [routerLink]="[item?.layoutContent?.banner?.link | pageIdFromLink]"
        [queryParams]="item?.layoutContent?.banner?.link | queryParamFromLink"
        [attr.aria-label]="item?.layoutContent?.title?.text || 'banner-link'"
        [style]="{
            display: 'flex',
            pointerEvents:
                item?.layoutContent?.banner?.link &&
                item?.layoutContent?.banner?.link !== ''
                    ? 'auto'
                    : 'none',
            width: '100%',
            overflow: 'hidden',
            borderRadius: borderRadius
        }"
    >
        <picture
            style="display: flex; width: 100%"
            *ngIf="!item?.layoutContent?.banner?.video"
        >
            <img
                [src]="item?.layoutContent?.banner.image"
                [alt]="item?.layoutContent?.title?.text || 'banner'"
                class="responsive-image"
            />
        </picture>
        <video
            *ngIf="item?.layoutContent?.banner?.video"
            poster="{{
                item?.layoutContent?.banner?.image + this.mediaCDN.getImageCDN()
            }}"
            style="
                clip-path: inset(0px);
                border: none;
                top: 0;
                height: auto;
                width: 100%;
            "
            loop
            muted
            autoplay
            oncanplay="this.play()"
            onloadedmetadata="this.muted = true"
            playsinline
            webkit-playsinline
            preload="auto"
        >
            <source
                src="{{
                    item?.layoutContent?.banner?.video +
                        this.mediaCDN.getVideoCDN()
                }}"
                type="video/webm"
            />
            <source
                [src]="
                    homepageService.convertWebToMp4(
                        item?.layoutContent?.banner?.video
                    )
                "
                type="video/mp4"
            />
        </video>
    </a>

    <!-- Bottom Content -->
    <div
        class="bottom-content"
        ngClass.xs="bottom-content__mobile"
        [ngStyle]="getBottomContentStyle()"
        *ngIf="
            item?.layoutContent?.title?.text ||
            item?.layoutContent?.subtitle?.text ||
            item?.layoutContent?.button?.title?.text
        "
    >
        <h1
            *ngIf="item?.layoutContent?.title?.text"
            class="title"
            ngClass.xs="title__mobile"
            [style]="{ color: item?.layoutContent?.title?.color }"
            [ngStyle.gt-xs]="{
                margin: item?.layoutContent?.subtitle?.text
                    ? '0 0 2px 0'
                    : '0 0 24px 0'
            }"
            [ngStyle.xs]="{
                margin: item?.layoutContent?.subtitle?.text
                    ? '0 0 2px 0'
                    : '0 0 16px 0'
            }"
            >{{ item?.layoutContent?.title?.text }}</h1
        >
        <p
            *ngIf="item?.layoutContent?.subtitle?.text"
            class="subtitle"
            ngClass.xs="subtitle__mobile"
            [innerHTML]="item?.layoutContent?.subtitle?.text | lineBreak"
            [style]="{ color: item?.layoutContent?.subtitle?.color }"
            >{{ item?.layoutContent?.subtitle?.text }}</p
        >
        <a
            *ngIf="item?.layoutContent?.button?.title?.text"
            [routerLink]="[item?.layoutContent?.button?.link | pageIdFromLink]"
            [queryParams]="
                item?.layoutContent?.button?.link | queryParamFromLink
            "
            style="text-decoration: none; display: flex; width: fit-content"
            [attr.aria-label]="
                item?.layoutContent?.button?.title?.text || 'button-link'
            "
        >
            <button
                *ngIf="item?.layoutContent?.button?.title?.text"
                class="button-with-round-corners"
                [style]="{
                    color: item?.layoutContent?.button?.title?.color,
                    background: item?.layoutContent?.button?.background?.color
                }"
                >{{ item?.layoutContent?.button?.title?.text }}</button
            >
        </a>
    </div>
</div>
